<template>
    <div>
        <h1 class="display-heading">Product Management</h1>

        <div class="card mb-3">
            <div class="card-header">Add Products</div>
            <div class="card-body">
                <router-link :to="{
                    'name': 'drug-detail-add',
                }" class="btn btn-primary btn-primary-insv mr-2">
                    Add Single Product
                </router-link>
                <router-link :to="{
                    'name': 'drug-upload',
                }" class="btn btn-primary btn-primary-insv mr-2">
                    Bulk Upload Products
                </router-link>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header">Search Products</div>
            <div class="card-body">
                <data-filter ref="dataFilter" :filters="filters"
                    searchText="Search Products"
                    clearSearchText="Clear Search"
                    @filterSearch="getFilterDrugs"
                    @filterReset="getFilterDrugs">
                </data-filter>
            </div>
        </div>
        <div ref="tableSection">
            <div class="table-responsive">
                <table ref="listTable" class="table table-hover">
                    <colgroup>
                        <col width="50">
                        <col width="120">
                        <col width="200">
                        <col>
                        <col width="150">
                        <col width="150">
                        <col width="110">
                        <col width="100">
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Code</th>
                            <th scope="col">Product Name</th>
                            <th scope="col">Active Ingredient</th>
                            <th scope="col">Unit of <br>Measurement</th>
                            <th scope="col">Min Order <br>Quantity</th>
                            <th scope="col" class="text-right pr-3">Unit Price</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="drugList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>

                        <tr v-for="(drug, index) in drugList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>
                            <td>
                                {{drug.productCode}}
                            </td>
                            <!-- <td>
                                {{drug.productCategory}}
                            </td> -->
                            <td>
                                {{drug.productName}}
                            </td>
                            <td>
                                {{drug.activeIngredients ? drug.activeIngredients : "-"}}
                            </td>
                            <td class="text-nowrap">
                                {{drug.unit}}
                            </td>
                            <td class="text-nowrap">
                                {{drug.minOrderQuantity}}
                            </td>
                            <td class="text-right pr-3">
                                {{drug.unitPrice}}
                            </td>
                            <td class="text-nowrap">
                                <router-link :to="{
                                    'name': 'drug-detail',
                                    'params': {
                                        'id': drug.drugId
                                    }
                                }" target="_blank">View / Edit</router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagination v-model="pagination.currentPage"
                    :totalPages="pagination.totalPages"
                    :scrollPosition="pagination.scrollPosition">
                </pagination>
            </div>
        </div>
    </div>
</template>

<script>
import dataFilter from '@/components/data-filter';
import pagination from '@/components/pagination';
export default {
    'name': 'DrugsList',
    'components': {
        dataFilter,
        pagination
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.$refs.dataFilter.filterSearch(false);
            });
        }
    },
    data () {
        return {
            'drugList': [],
            'columnsCount': 1,
            'isTableLoading': true,
            'filters': [
                {
                    'label': 'Product Code',
                    'type': 'text',
                    'value': '',
                    'placeholder': 'Enter Product Code',
                    'objectKey': 'pc'
                },
                {
                    'label': 'Product Name',
                    'type': 'text',
                    'value': '',
                    'placeholder': 'Enter Product Name',
                    'objectKey': 'pn'
                },
                {
                    'label': 'Active Ingredient',
                    'type': 'text',
                    'value': '',
                    'placeholder': 'Enter Active Ingredient',
                    'objectKey': 'ai'
                }
            ],
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            }
        };
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.$refs.dataFilter.filterSearch();
    },
    'methods': {
        getFilterDrugs (data) {
            this.isTableLoading = true;
            if (data.shouldResetPaging) {
                this.pagination.currentPage = 1;
            }

            let dataFilter = data.data;
            let productCode = dataFilter.find(f => f.objectKey === 'pc') ? dataFilter.find(f => f.objectKey === 'pc').value : '';
            let productName = dataFilter.find(f => f.objectKey === 'pn') ? dataFilter.find(f => f.objectKey === 'pn').value : '';
            let productActiveIngredient = dataFilter.find(f => f.objectKey === 'ai') ? dataFilter.find(f => f.objectKey === 'ai').value : '';

            this.axios.post('Drugs/GetDrugList', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize,
                'pc': productCode,
                'pn': productName,
                'ai': productActiveIngredient
            }).then(({
                data
            }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;
                this.drugList = list.map((drug) => ({
                    'drugId': drug.di,
                    'productCode': drug.pc,
                    'productCategory': drug.pcat,
                    'productName': drug.pn,
                    'activeIngredients': drug.ai,
                    'unit': drug.u,
                    'conversionFactor': drug.cf,
                    'unitPrice': drug.up.toFixed(2),
                    'minOrderQuantity': drug.moq,
                    'unitQuantity': drug.uq,
                    'remarks': drug.r
                }));
            }).catch(({
                response
            }) => {

            });
        }
    }
};
</script>

<style>

</style>
